<template>
    <div id="loyalty-program-page">
        <LandingBannner />
        <ExtraInfo />
        <LoyaltyLevel />
    </div>
</template>
      
<script>
import sal from 'sal.js'
import LandingBannner from '../../components/landing-components/loyalty-program-components/LandingBannner.vue';
import ExtraInfo from '../../components/landing-components/loyalty-program-components/ExtraInfo.vue';
import LoyaltyLevel from '../../components/landing-components/loyalty-program-components/LoyaltyLevel.vue';
export default {
    name: "HomePage",
    components: {
    LandingBannner,
    ExtraInfo,
    LoyaltyLevel
},
    mounted() {
        sal();
    },
}
</script>
      
<style scoped></style>